export const environment = {
  production: false,
  serverUrl: 'https://devbackapi.auriscom.com',
  loginUrl: 'https://devbackapi.auriscom.com/login',
  signUpUrl: 'https://devbackapi.auriscom.com/signup',
  application: {},
  config: {
    api: false,
    url: './assets/params/json/crud/'
  }
};
